import styled, { css } from 'styled-components';

import Picture from 'components/picture';

import { DESKTOP_TILE_IMAGE_HEIGHT } from './constants';

export const PriceAndCaloriesListWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  ${Styles.desktop`
    display: block;
  `}
`;

export const StyledTileDescription = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0rem 2rem;
  overflow: ellipsis;

  ${Styles.mobile`
    height: 3.75rem;
    padding: 0.5rem;
    text-align: center;
  `}

  h2 {
    color: ${Styles.color.black};
    font-family: ${Styles.fontFamily.base};
    line-height: 1.11;
    font-size: 1.125rem;
    margin: 0;
    text-transform: ${Styles.textTransform.headlines};
  }

  p {
    color: ${Styles.color.grey.two};
    font-family: ${Styles.fontFamily.body};
    margin-top: 0.25rem;
  }
`;

export const tileHeaderStyles = css`
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.base};
  line-height: 1.11;
  font-size: 1.125rem;
  margin: 0;
  text-transform: ${Styles.textTransform.headlines};

  ${Styles.desktop`
    font-size: 1.375rem;
  `}
`;

export const TileInner = styled.div``;

export const TileImage = styled(Picture)<{ $isOnMainMenu?: boolean }>`
  overflow: hidden;
  position: relative;
  border-radius: ${Styles.borderRadius} ${Styles.borderRadius} 0 0;
  height: 6.25rem;

  ${Styles.desktop`
     height: 15rem;
  `}
`;

export const ListTileImage = styled(Picture)<{ $isOnMainMenu?: boolean }>`
  overflow: hidden;
  position: relative;
  border-radius: ${Styles.borderRadius};
  height: 4.5rem;
  width: 6.5rem;

  ${p => Styles.desktop`
    height: ${p.$isOnMainMenu ? '15rem' : DESKTOP_TILE_IMAGE_HEIGHT};
    width: unset;
    border-radius: ${Styles.borderRadius} ${Styles.borderRadius} 0 0;
  `}
`;

export const ItemPrice = styled.span`
  font-weight: ${Styles.fontWeight.heavy};
  color: ${Styles.color.pricing};
`;
